export const GET_PORTFOLIOS = 'portfolios/GET_PORTFOLIOS'
export const GET_PORTFOLIO = 'portfolios/GET_PORTFOLIO'
export const ADD_PORTFOLIO = 'portfolios/ADD_PORTFOLIOS'
export const EDIT_PORTFOLIO = 'portfolios/EDIT_PORTFOLIOS'
export const DELETE_PORTFOLIOS = 'portfolios/DELETE_PORTFOLIOS'
export const START_LOADING_PORTFOLIOS =
  'portfolios/START_LOADING_PORTFOLIOS'
export const STOP_LOADING_PORTFOLIOS =
  'portfolios/STOP_LOADING_PORTFOLIOS'